import { useTranslation } from "react-i18next";
import Player from "lottie-react";
import animationData from "@src/assets/lottie/Success.json";
import Container from "@src/components/shared/Container";
import TitleAndDesc from "@src/components/shared/TitleAndDesc";
import { useLocation, Link } from "react-router-dom";
import { Button } from "../ui/button";

function Success() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const { title, description, btn } = location.state || {};

  return (
    <Container className="max-md:min-h-[90vh] min-h-full max-md:bg-white pt-9">
      <div className="flex flex-1 flex-col items-center justify-center max-md:min-h-[60vh] md:pb-10">
        <div className="mx-auto h-[180px] w-[180px]">
          <Player
            loop={false}
            autoplay={true}
            animationData={animationData}
            rendererSettings={{
              preserveAspectRatio: "xMidYMid slice",
            }}
          />
        </div>
        <div className="py-4 flex justify-center text-center max-w-[400px] pt-4">
          <TitleAndDesc
            desc={description || t("success.desc")}
            title={title || t("success.title")}
          />
        </div>
        {btn == "hide" ? (
          <></>
        ) : (
          <div
            className="w-full self-end rounded-[6px] bg-white py-8
           max-md:absolute max-md:bottom-0 max-md:left-0 max-md:right-0 max-md:px-4 "
          >
            <Link
              className="w-full  flex justify-center"
              to={`https://whitebit.ge/${i18n.language}`}
            >
              <Button className="w-full max-w-[300px] mx-auto">
                {t("success.backToHome")}
              </Button>
            </Link>
          </div>
        )}
      </div>
    </Container>
  );
}

export default Success;
